import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import './Header.css';

class Header extends React.Component {
  static propTypes = {
    routes: PropTypes.arrayOf(PropTypes.shape({
      path: PropTypes.string,
    })).isRequired,
  };

  render() {
    const routes = this.props.routes
      .filter(r => !!r.title)
      .map(r => (
        <li key={`${r.path}-${r.title}`}>
          <NavLink to={r.path} exact={r.exact} activeClassName="active">{r.title}</NavLink>
        </li>
      ));

    return (
      <header className="Header">
        <ul>
          {routes}
        </ul>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js